export default __webpack_public_path__ + "static/media/2.1db9d2d6.jpg";